import { NgModule } from 'angular-ts-decorators';
import { moduleName } from '../constants';

import { HeroCustomizerV3AccessoriesComponent } from './hero-customizer-v3-accessories.component';

@NgModule({
  declarations: [
    HeroCustomizerV3AccessoriesComponent,
  ],
  id: `${moduleName}.accessories`,
  providers: [],
})
export class HeroCustomizerV3AccessoriesModule {
}
